ui-cms-navigation {
  @include breakpoint($desktop) {
    position: relative;

    // navigation flyout
    .position-helper {
      display: block !important;
      visibility: hidden;
    }
  }

  // main navigation 1st level
  .main-navigation {
    @include reset-ul();
    position: relative;
    display: flex;
    list-style: none;
  }

  .menuItemMeta {
    font-size: $metadata-font-size;
    line-height: $metadata-line-height;
  }
}
